import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=dbd66d46"
import script from "./StudentDetails.vue?vue&type=script&lang=js"
export * from "./StudentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports